// src/utils/constants.js - Version améliorée avec calcul CG depuis étiquette

// Google Drive API configuration — valeurs injectées via variables d'environnement Netlify
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || '';
export const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';
export const BACKUP_FILE_NAME = 'glycemic_index_backup.json';
export const SCOPE = 'https://www.googleapis.com/auth/drive.file';

// Base food data - Source de vérité unique (27 aliments officiels)
export const BASE_FOODS = [
  { id: 1, name: "Tomate cœur de bœuf", gi: 15, carbs: 3.9, gl: 1.0, category: "très faible", source: "master" },
  { id: 2, name: "Oignon", gi: 15, carbs: 9.3, gl: 1.0, category: "très faible", source: "master" },
  { id: 3, name: "Épinards à la crème", gi: 15, carbs: 4.5, gl: 1.0, category: "très faible", source: "master" },
  { id: 4, name: "Boisson énergisante (sans sucre)", gi: 0, carbs: 0.7, gl: 0, category: "très faible", source: "master" },
  { id: 5, name: "Carotte", gi: 35, carbs: 10, gl: 4.0, category: "très faible", source: "master" },
  { id: 6, name: "Poêlée de légumes à la parisienne", gi: 50, carbs: 8.6, gl: 4.0, category: "très faible", source: "master" },
  { id: 7, name: "Betterave rouge", gi: 64, carbs: 10, gl: 6.0, category: "faible", source: "master" },
  { id: 8, name: "Lentilles", gi: 30, carbs: 20, gl: 6.0, category: "faible", source: "master" },
  { id: 9, name: "Amigo Pamplemousse", gi: 65, carbs: 9.2, gl: 6.0, category: "faible", source: "master" },
  { id: 10, name: "Maïs", gi: 55, carbs: 19, gl: 10.0, category: "faible", source: "master" },
  { id: 11, name: "Pomme de terre", gi: 77, carbs: 17, gl: 13.0, category: "modérée", source: "master" },
  { id: 12, name: "Banane jaune/Plantain (peu mûre)", gi: 40, carbs: 32, gl: 13.0, category: "modérée", source: "master" },
  { id: 13, name: "Banane/Figue (mûre)", gi: 60, carbs: 23, gl: 14.0, category: "modérée", source: "master" },
  { id: 14, name: "Crêpe jambon fromage", gi: 60, carbs: 25, gl: 15.0, category: "modérée", source: "master" },
  { id: 15, name: "Fruit à pain", gi: 68, carbs: 25, gl: 17.0, category: "modérée", source: "master" },
  { id: 16, name: "Tacos à la viande hachée", gi: 55, carbs: 30, gl: 17.0, category: "modérée", source: "master" },
  { id: 17, name: "Chocolat noir (53% cacao)", gi: 40, carbs: 50.7, gl: 20.0, category: "élevée", source: "master" },
  { id: 18, name: "Pâtes au blé complet", gi: 45, carbs: 65, gl: 29.0, category: "élevée", source: "master" },
  { id: 19, name: "Sucre de coco", gi: 35, carbs: 93, gl: 33.0, category: "élevée", source: "master" },
  { id: 20, name: "Riz complet", gi: 50, carbs: 77, gl: 39.0, category: "élevée", source: "master" },
  { id: 21, name: "Barre Mars", gi: 65, carbs: 68, gl: 44.0, category: "élevée", source: "master" },
  { id: 22, name: "Riz basmati", gi: 58, carbs: 78, gl: 45.0, category: "élevée", source: "master" },
  { id: 23, name: "Semoule de blé", gi: 65, carbs: 75, gl: 49.0, category: "élevée", source: "master" },
  { id: 24, name: "Raisins secs", gi: 65, carbs: 79, gl: 51.0, category: "élevée", source: "master" },
  { id: 25, name: "Riz blanc", gi: 70, carbs: 79, gl: 55.0, category: "élevée", source: "master" },
  { id: 26, name: "Sucre roux", gi: 65, carbs: 98, gl: 64.0, category: "élevée", source: "master" },
  { id: 27, name: "Sucre blanc", gi: 70, carbs: 100, gl: 70.0, category: "élevée", source: "master" }
];

// Open Food Facts API
export const OPEN_FOOD_FACTS_API = {
  PRODUCT_URL: 'https://world.openfoodfacts.org/api/v2/product',
  SEARCH_URL: 'https://world.openfoodfacts.org/cgi/search.pl',
  DEFAULT_PAGE_SIZE: 10,
  MAX_RESULTS: 5
};

// Categories and their thresholds
export const GLYCEMIC_LOAD_CATEGORIES = {
  VERY_LOW: { threshold: 5, name: 'très faible', emoji: '🟢' },
  LOW: { threshold: 10, name: 'faible', emoji: '🟡' },
  MODERATE: { threshold: 20, name: 'modérée', emoji: '🟠' },
  HIGH: { threshold: Infinity, name: 'élevée', emoji: '🔴' }
};

// Enhanced GI estimation by food categories (for Open Food Facts)
export const GI_ESTIMATION_BY_CATEGORY = {
  // Légumes et verdures (IG très bas)
  vegetable: 25,
  green: 20,
  leafy: 15,
  salad: 15,
  tomato: 15,
  cucumber: 15,
  lettuce: 10,
  spinach: 15,
  broccoli: 15,
  
  // Fruits (IG bas à modéré)
  fruit: 40,
  apple: 35,
  orange: 35,
  banana: 50,
  grape: 45,
  berry: 25,
  strawberry: 25,
  blueberry: 25,
  
  // Légumineuses (IG bas)
  legume: 30,
  lentil: 30,
  bean: 35,
  chickpea: 35,
  pea: 35,
  
  // Produits laitiers (IG bas)
  dairy: 30,
  milk: 30,
  yogurt: 35,
  cheese: 0, // Pas de glucides significatifs
  
  // Céréales et féculents
  cereal: 60,
  oat: 55,
  quinoa: 35,
  rice: 70,
  'brown-rice': 50,
  'white-rice': 70,
  'basmati-rice': 50,
  
  // Pains et produits de boulangerie
  bread: 70,
  'white-bread': 75,
  'whole-wheat-bread': 65,
  'whole-grain-bread': 50,
  baguette: 85,
  toast: 70,
  cracker: 65,
  
  // Pâtes
  pasta: 45,
  noodle: 45,
  spaghetti: 40,
  
  // Pommes de terre
  potato: 75,
  'mashed-potato': 85,
  'french-fries': 75,
  'sweet-potato': 50,
  
  // Produits sucrés
  sugar: 68,
  honey: 55,
  jam: 65,
  chocolate: 65,
  candy: 70,
  cookie: 65,
  cake: 70,
  
  // Boissons
  beverage: 50,
  juice: 50,
  'orange-juice': 50,
  'apple-juice': 40,
  soda: 65,
  cola: 65,
  
  // Snacks et grignotages
  snack: 60,
  chip: 55,
  pretzel: 80,
  popcorn: 65,
  
  // Condiments et sauces
  sauce: 35,
  ketchup: 55,
  
  // Default
  default: 50
};

// Enhanced nutritional factors for GI estimation
export const NUTRITIONAL_GI_FACTORS = {
  // Facteurs qui augmentent l'IG
  HIGH_SUGAR_THRESHOLD: 15, // g/100g
  HIGH_SUGAR_PENALTY: 20,
  MODERATE_SUGAR_THRESHOLD: 5,
  MODERATE_SUGAR_PENALTY: 10,
  
  // Facteurs qui diminuent l'IG
  HIGH_FIBER_THRESHOLD: 10, // g/100g
  HIGH_FIBER_BONUS: -15,
  MODERATE_FIBER_THRESHOLD: 5,
  MODERATE_FIBER_BONUS: -10,
  LOW_FIBER_THRESHOLD: 2,
  LOW_FIBER_BONUS: -5,
  
  HIGH_PROTEIN_THRESHOLD: 15, // g/100g
  HIGH_PROTEIN_BONUS: -10,
  MODERATE_PROTEIN_THRESHOLD: 8,
  MODERATE_PROTEIN_BONUS: -5,
  
  HIGH_FAT_THRESHOLD: 15, // g/100g
  HIGH_FAT_BONUS: -10,
  MODERATE_FAT_THRESHOLD: 8,
  MODERATE_FAT_BONUS: -5,
  
  // Facteurs de traitement/transformation
  PROCESSING_PENALTY: 10, // Pour aliments ultra-transformés
  REFINED_PENALTY: 15, // Pour céréales raffinées
  
  // Limites IG
  MIN_GI: 15,
  MAX_GI: 100
};

// CG targets for different populations
export const CG_TARGETS = {
  DIABETIC: {
    PER_MEAL: 5,
    DAILY_LOW: 50,
    DAILY_MODERATE: 80,
    DAILY_HIGH: 120
  },
  WEIGHT_MANAGEMENT: {
    PER_MEAL: 10,
    DAILY_LOW: 80,
    DAILY_MODERATE: 100,
    DAILY_HIGH: 150
  },
  ATHLETIC: {
    PRE_WORKOUT: 15,
    POST_WORKOUT: 25,
    DAILY_LOW: 100,
    DAILY_MODERATE: 150,
    DAILY_HIGH: 200
  },
  GENERAL: {
    PER_MEAL: 15,
    DAILY_LOW: 80,
    DAILY_MODERATE: 120,
    DAILY_HIGH: 180
  }
};

// Auto-save delay for Google Drive
export const AUTO_SAVE_DELAY = 3000; // 3 seconds

// Enhanced camera settings
export const CAMERA_SETTINGS = {
  video: { 
    facingMode: 'environment',
    width: { ideal: 1280, min: 640 },
    height: { ideal: 720, min: 480 },
    focusMode: 'continuous'
  }
};

// Camera constraints for different scenarios
export const CAMERA_SCENARIOS = {
  BARCODE: {
    video: {
      facingMode: 'environment',
      width: { ideal: 1280, min: 640 },
      height: { ideal: 720, min: 480 },
      focusMode: 'continuous',
      focusDistance: { ideal: 0.1 }
    }
  },
  PHOTO: {
    video: {
      facingMode: 'environment',
      width: { ideal: 1920, min: 1280 },
      height: { ideal: 1080, min: 720 }
    }
  },
  SELFIE: {
    video: {
      facingMode: 'user',
      width: { ideal: 1280, min: 640 },
      height: { ideal: 720, min: 480 }
    }
  }
};

// Tab names
export const TABS = {
  SEARCH: 'search',
  OPEN_FOOD_FACTS: 'openfoodfacts',
  CALCULATOR: 'calculator',
  ADD: 'add',
  GUIDE: 'guide',
  SYNC: 'sync',
  RECIPES: 'recipes',
  RECIPE_VIEW: 'recipe_view',
  PANTRY: 'pantry'
};

// Notification types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// App configuration
export const APP_CONFIG = {
  NAME: 'Gestion des Indices Glycémiques',
  VERSION: '2.1.0',
  AUTHOR: 'Développé avec Claude',
  DESCRIPTION: 'Application de gestion des indices et charges glycémiques avec analyse nutritionnelle avancée',
  SUPPORT_EMAIL: 'support@sucre.bifrhost.com',
  PRIVACY_URL: 'https://sucre.bifrhost.com/privacy',
  TERMS_URL: 'https://sucre.bifrhost.com/terms',
  FEATURES: [
    'Calcul automatique de la charge glycémique depuis les étiquettes',
    'Estimation intelligente de l\'indice glycémique',
    'Analyse nutritionnelle détaillée',
    'Recommandations personnalisées par profil',
    'Scanner de codes-barres avec diagnostic',
    'Synchronisation Google Drive',
    'Base de données Open Food Facts'
  ]
};

// Error messages for camera
export const CAMERA_ERRORS = {
  NOT_ALLOWED: 'Permission caméra refusée. Veuillez autoriser l\'accès à la caméra.',
  NOT_FOUND: 'Aucune caméra trouvée sur cet appareil.',
  NOT_READABLE: 'Caméra déjà utilisée par une autre application.',
  OVERCONSTRAINED: 'Paramètres de caméra non supportés par votre appareil.',
  SECURITY_ERROR: 'Erreur de sécurité. Veuillez utiliser HTTPS.',
  ABORT_ERROR: 'Opération caméra annulée.',
  INSECURE_CONTEXT: 'La caméra nécessite une connexion sécurisée (HTTPS).',
  UNSUPPORTED: 'Caméra non supportée sur cet appareil.'
};

// Browser-specific permission instructions
export const PERMISSION_INSTRUCTIONS = {
  CHROME: {
    name: 'Chrome',
    steps: [
      'Cliquez sur l\'icône caméra dans la barre d\'adresse',
      'Sélectionnez "Toujours autoriser"',
      'Rechargez la page'
    ]
  },
  FIREFOX: {
    name: 'Firefox',
    steps: [
      'Cliquez sur l\'icône bouclier dans la barre d\'adresse',
      'Autorisez l\'accès à la caméra',
      'Rechargez la page'
    ]
  },
  SAFARI: {
    name: 'Safari',
    steps: [
      'Allez dans Safari > Préférences',
      'Onglet Sites web > Caméra',
      'Autorisez ce site'
    ]
  },
  EDGE: {
    name: 'Edge',
    steps: [
      'Cliquez sur l\'icône de paramètres dans la barre d\'adresse',
      'Sélectionnez "Autorisations pour ce site"',
      'Autorisez l\'accès à la caméra'
    ]
  },
  DEFAULT: {
    name: 'Navigateur',
    steps: [
      'Vérifiez les paramètres de votre navigateur',
      'Autorisez l\'accès à la caméra pour ce site',
      'Rechargez la page'
    ]
  }
};

// Data quality thresholds for OFF products
export const DATA_QUALITY_THRESHOLDS = {
  EXCELLENT: 0.9,
  GOOD: 0.7,
  FAIR: 0.5,
  POOR: 0.3
};

// Confidence levels for GI estimation
export const CONFIDENCE_LEVELS = {
  HIGH: {
    name: 'élevée',
    color: 'green',
    description: 'Estimation fiable basée sur des données complètes'
  },
  MEDIUM: {
    name: 'moyenne',
    color: 'yellow',
    description: 'Estimation correcte mais données partielles'
  },
  LOW: {
    name: 'faible',
    color: 'red',
    description: 'Estimation approximative avec données limitées'
  }
};

// Portion size recommendations
export const PORTION_RECOMMENDATIONS = {
  VERY_SMALL: {
    range: '5-20g',
    description: 'Condiments, épices'
  },
  SMALL: {
    range: '20-50g',
    description: 'Snacks, fruits secs'
  },
  MEDIUM: {
    range: '50-150g',
    description: 'Fruits, légumes, yaourts'
  },
  LARGE: {
    range: '150-300g',
    description: 'Féculents, plats principaux'
  },
  VERY_LARGE: {
    range: '300g+',
    description: 'Soupes, salades'
  }
};

// Meal timing recommendations for diabetics
export const MEAL_TIMING = {
  BREAKFAST: {
    target_cg: 10,
    timing: '07:00-09:00',
    recommendations: [
      'Privilégier les fibres et protéines',
      'Éviter les sucres rapides',
      'Inclure des graisses saines'
    ]
  },
  LUNCH: {
    target_cg: 15,
    timing: '12:00-14:00',
    recommendations: [
      'Équilibrer glucides complexes et protéines',
      'Commencer par les légumes',
      'Modérer les portions de féculents'
    ]
  },
  DINNER: {
    target_cg: 10,
    timing: '18:00-20:00',
    recommendations: [
      'Réduire les glucides le soir',
      'Privilégier légumes et protéines',
      'Éviter les desserts sucrés'
    ]
  },
  SNACK: {
    target_cg: 5,
    timing: 'Entre les repas',
    recommendations: [
      'Collations riches en fibres',
      'Associer protéines et glucides complexes',
      'Éviter les grignotages sucrés'
    ]
  }
};

// Exercise and CG recommendations
export const EXERCISE_CG_RECOMMENDATIONS = {
  PRE_WORKOUT: {
    timing: '30-60 min avant',
    target_cg: 15,
    foods: ['Banane', 'Avoine', 'Dattes'],
    avoid: ['Aliments gras', 'Fibres excessives']
  },
  DURING_WORKOUT: {
    timing: 'Pendant (>1h)',
    target_cg: 20,
    foods: ['Boisson énergétique', 'Gel énergétique'],
    avoid: ['Aliments solides', 'Fibres']
  },
  POST_WORKOUT: {
    timing: '0-30 min après',
    target_cg: 25,
    foods: ['Fruits', 'Yaourt', 'Chocolat au lait'],
    avoid: ['Graisses', 'Alcool']
  },
  RECOVERY: {
    timing: '2-4h après',
    target_cg: 15,
    foods: ['Féculents complets', 'Légumineuses'],
    avoid: ['Sucres simples seuls']
  }
};

// Blood glucose target ranges (informational only)
export const GLUCOSE_TARGETS = {
  NORMAL: {
    fasting: '70-100 mg/dL (3.9-5.6 mmol/L)',
    postprandial: '<140 mg/dL (<7.8 mmol/L)',
    hba1c: '<5.7%'
  },
  PREDIABETIC: {
    fasting: '100-125 mg/dL (5.6-6.9 mmol/L)',
    postprandial: '140-199 mg/dL (7.8-11.0 mmol/L)',
    hba1c: '5.7-6.4%'
  },
  DIABETIC: {
    fasting: '≥126 mg/dL (≥7.0 mmol/L)',
    postprandial: '≥200 mg/dL (≥11.1 mmol/L)',
    hba1c: '≥6.5%'
  },
  DIABETIC_TARGET: {
    fasting: '80-130 mg/dL (4.4-7.2 mmol/L)',
    postprandial: '<180 mg/dL (<10.0 mmol/L)',
    hba1c: '<7%'
  }
};

// Educational content categories
export const EDUCATIONAL_CONTENT = {
  BASICS: {
    title: 'Bases de la glycémie',
    topics: [
      'Qu\'est-ce que l\'indice glycémique ?',
      'Différence entre IG et charge glycémique',
      'Impact sur la santé',
      'Facteurs qui influencent l\'IG'
    ]
  },
  PRACTICAL: {
    title: 'Application pratique',
    topics: [
      'Lire les étiquettes nutritionnelles',
      'Calculer la charge glycémique',
      'Planifier ses repas',
      'Gérer les portions'
    ]
  },
  MEDICAL: {
    title: 'Aspects médicaux',
    topics: [
      'Diabète et alimentation',
      'Surveillance glycémique',
      'Médication et repas',
      'Complications à éviter'
    ]
  },
  LIFESTYLE: {
    title: 'Mode de vie',
    topics: [
      'Exercice et glycémie',
      'Stress et glycémie',
      'Sommeil et métabolisme',
      'Hydratation'
    ]
  }
};

// API rate limiting
export const API_LIMITS = {
  OPEN_FOOD_FACTS: {
    requests_per_minute: 60,
    requests_per_hour: 1000,
    timeout: 10000 // 10 seconds
  },
  GOOGLE_DRIVE: {
    requests_per_minute: 100,
    requests_per_hour: 1000,
    timeout: 30000 // 30 seconds
  }
};

// Local storage keys
export const STORAGE_KEYS = {
  FOODS: 'glycemic_foods',
  SELECTED_FOODS: 'glycemic_selected_foods',
  USER_PREFERENCES: 'glycemic_preferences',
  LAST_SYNC: 'glycemic_last_sync',
  CAMERA_PERMISSIONS: 'glycemic_camera_permissions',
  TUTORIAL_COMPLETED: 'glycemic_tutorial_completed'
};

// Default user preferences
export const DEFAULT_PREFERENCES = {
  target_profile: 'general', // diabetic, weight_management, athletic, general
  units: 'metric', // metric, imperial
  language: 'fr',
  notifications: {
    sync_success: true,
    sync_error: true,
    new_product_added: true,
    daily_cg_summary: false
  },
  display: {
    show_detailed_analysis: true,
    show_confidence_levels: true,
    show_portion_recommendations: true,
    default_portion_size: 100
  },
  privacy: {
    analytics: false,
    crash_reporting: true,
    usage_statistics: false
  }
};

// Feature flags for progressive deployment
export const FEATURE_FLAGS = {
  ENHANCED_CG_CALCULATION: true,
  DETAILED_NUTRITION_ANALYSIS: true,
  CAMERA_BARCODE_SCANNING: true,
  GOOGLE_DRIVE_SYNC: false, // Désactivé — remplacé par Netlify DB (usage familial partagé)
  MEAL_PLANNING: false, // Future feature
  GLUCOSE_TRACKING: false, // Future feature
  RECIPE_ANALYSIS: false, // Future feature
  SOCIAL_SHARING: false, // Future feature
  OFFLINE_MODE: false // Future feature
};

// Version history and migration
export const VERSION_HISTORY = {
  '1.0.0': {
    date: '2024-01-01',
    features: ['Basic IG database', 'Simple CG calculation']
  },
  '2.0.0': {
    date: '2024-06-01',
    features: ['Open Food Facts integration', 'Google Drive sync', 'Enhanced UI']
  },
  '2.1.0': {
    date: '2024-06-05',
    features: [
      'CG calculation from nutrition labels',
      'Enhanced camera diagnostics',
      'Detailed nutritional analysis',
      'Improved GI estimation algorithms'
    ]
  }
};

// Export all constants as named exports and create a default export
const constantsDefault = {
  GOOGLE_CLIENT_ID,
  GOOGLE_API_KEY,
  DISCOVERY_DOC,
  BACKUP_FILE_NAME,
  SCOPE,
  BASE_FOODS,
  OPEN_FOOD_FACTS_API,
  GLYCEMIC_LOAD_CATEGORIES,
  GI_ESTIMATION_BY_CATEGORY,
  NUTRITIONAL_GI_FACTORS,
  CG_TARGETS,
  AUTO_SAVE_DELAY,
  CAMERA_SETTINGS,
  CAMERA_SCENARIOS,
  TABS,
  NOTIFICATION_TYPES,
  APP_CONFIG,
  CAMERA_ERRORS,
  PERMISSION_INSTRUCTIONS,
  DATA_QUALITY_THRESHOLDS,
  CONFIDENCE_LEVELS,
  PORTION_RECOMMENDATIONS,
  MEAL_TIMING,
  EXERCISE_CG_RECOMMENDATIONS,
  GLUCOSE_TARGETS,
  EDUCATIONAL_CONTENT,
  API_LIMITS,
  STORAGE_KEYS,
  DEFAULT_PREFERENCES,
  FEATURE_FLAGS,
  VERSION_HISTORY
};

export default constantsDefault;